module.exports = __webpack_public_path__ + "img/avp_bck_alt_phone@2x.9946fe0.webp";